import { ResourceOptions } from 'react-admin';
import { FaTasks } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxTasks;
export const icon = FaTasks;
export const options: ResourceOptions = {
  label: 'module.blindBox.tasks',
};
